import { Component, OnInit } from '@angular/core';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {Router} from '@angular/router';
import {RequestHandler} from '../../../../service/OffService/request-handler';
import {Utils} from '../../../../common/utils';
import {RequestButtonTypes} from '../../../../common/components/request-button/request-button.component';
import {VentasApiService} from '../../../../service/api/ventas-api.service';
import {BaseView} from '../../../base-view';

import { Compradores } from 'src/app/models/ventas/compradores.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { CompradoresFormDefinition } from './compradores-form/form-definition';
import { CompradoresEnvironmentDefinition } from './environment-variables';
import { FormType } from '@fitogest/reactive-form-builder/interfaces';
@Component({
    selector: 'app-compradores',
    standalone: false,
    templateUrl: './compradores.component.html',
    styleUrls: ['./compradores.component.scss']
})
export class CompradoresComponent extends BaseView<Compradores> implements OnInit {
    /** Reactive form definition (initialized in `show()`). */
    public form!: CompradoresFormDefinition;
    
    /** Environment/feature flags for this view. */
    public readonly env = new CompradoresEnvironmentDefinition();
    public getRequest: RequestHandler<Compradores[]> = this.ventasApi.compradoresGET;
    public deleteRequest: RequestHandler<Compradores> = this.ventasApi.compradoresDELETE;
    public pathToForm = 'compradores-form';
    public menuItemId = 'compradores';
    public textoAnyadir = 'Añadir ' + this.env.comercioName;


    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public override canShow: Record<string, boolean> = {};
    public override model = {} as Compradores;

    
    public cols: ColInterface[] = [
        {field: 'razon_social', header: 'Razón Social', filter: '',  width: '240px'},
        {field: 'nif', header: 'NIF'},
        {field: 'codigo_postal', header: 'Código Postal'},
        {field: 'poblacion', header: 'Población', filter: ''},
        {field: 'provincia', header: 'Provincia', filter: '', visible: this.env.appName !== 'cartagenafresh'},
        {field: 'direccion', header: 'Dirección', filter: '', visible: this.env.appName === 'agrosol'},
        {field: 'pais', header: 'País', filter: '', visible: this.env.appName === 'cartagenafresh'},
        {field: 'rgseaa', header: 'RGSEAA', filter: ''},
        {field: 'tipo', header: 'Tipo', visible: this.env.showVentasComercioProveedor }
    ];

    constructor(private dashboard: DashboardService,
        private ventasApi: VentasApiService,
        private router: Router) {
        super(dashboard, ventasApi.compradoresGET);

    }

    ngOnInit() {
        this.dashboard.setSubmenuItem('compradores', this.menuItemId);
    }


    public add() {
        this.router.navigate(['dashboard', 'crear-comprador']);
    }

    public edit(data: Compradores) {
        this.router.navigate(['dashboard', 'editar-comprador', data.id]);
    }
    
    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {

        if (Utils.isNumber(value) && col.field === 'rgseaa' ) {
            return {
                textAlign: 'right',
                paddingRight: '70px',
            };
        }
        if (col.field === 'razon_social') {
            return {
                textAlign: 'left'
            };
            
        }

        else{
            return {textAlign: 'center'};
        }
    }

    public globalVisualTransform(value: string) {
        return value;
    }

    public override show(modal: string, data: Compradores) {
        let x;

        this.model = data;
        this.canShow[modal] = true;

        for (x in this.canShow) {
            if (x !== modal && this.canShow[x]) {
                this.canShow[x] = false;
            }
        }

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;
        this.form = new CompradoresFormDefinition(formType, data as unknown as Record<string, string>, null);
    }

    public override hide(modal: string) {
        this.model = {} as Compradores;
        this.canShow[modal] = false;
        this.deleteRequest.reset();
    }
}
